import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { LabelledLinkWebElement } from './LabelledLinkWebElement';
export { LabelledLinkWebElement };

/**
 * Retrieve an instance of [LabelledLinkWebElement](../classes/LabelledLinkWebElement.html).
 * @example
 * ```javascript
 * import { findLabelledLink } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findLabelledLink(driver, By.id('my-oj-c-labelled-link'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findLabelledLink(
  driver: DriverLike,
  by: By
): Promise<LabelledLinkWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type LabelledLinkWebElement
  if (!(webEl instanceof LabelledLinkWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'LabelledLinkWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findLabelledLink(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${LabelledLinkWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-labelled-link', LabelledLinkWebElement);
